if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = document.querySelector('.product-information');
      // this.productInfo = this.productSection?.querySelector('.product-info');
      this.productForm = this.productSection?.querySelector('.shopify-product-form');
      this.productFormButton = this.productForm?.querySelector('button[type="submit"]');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const bodyStyles = window.getComputedStyle(document.body);
      const headerOffset = parseInt(bodyStyles.getPropertyValue('--header-group-height'), 10) || 0;
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry) return;
        const fullyPastTop = entry.boundingClientRect.bottom <= headerOffset;
        this.classList.toggle('sticky-atc-panel--out', !fullyPastTop);
      }, {
        rootMargin: `-${headerOffset}px 0px 0px 0px`,
        threshold: 0
      });

      if (this.productForm) observer.observe(this.productForm);
      // if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
